import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@upmc/ims.component-library';
import useFormInput from '../../../../utils/hooks/useFormInput';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { Subtitle2 } from '../../../../components/UI/MDC/Typography/Typography';
import { CSS_CLASSES } from './_constants';

import classes from './SurveyorGuidelineAcknowledgment.module.scss';

const SurveyorGuidelineAcknowledgment = props => {
	const { field, meta } = useFormInput(props);

	return (
		<Fragment>
			<StyleAuxiliary classes={classes[CSS_CLASSES.CHECKBOX_CONTAINER]}>
				<Checkbox
					{...field}
					label={
						<div style={{'white-space': 'normal'}}>
							User has been provided with a copy of{' '}
							<a
								target='_blank'
								rel='noreferrer'
								href={
									'https://ims.upmc.com/ViewDocument.aspx?doc=government_surveyor_guidelines.pdf'
								}
							>
								UPMC Surveyor Guidelines.
							</a>{' '}
						</div>
					}
				/>
			</StyleAuxiliary>
			{meta && meta.touched && meta.error && (
				<Subtitle2 className={classes[CSS_CLASSES.INVALID]}>
					{meta.error}
				</Subtitle2>
			)}
		</Fragment>
	);
};

SurveyorGuidelineAcknowledgment.propTypes = {
	name: PropTypes.string,
};

export { SurveyorGuidelineAcknowledgment };
